<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              <div>뉴스레터 등록 기본정보</div>
            </strong>
          </div>
          <div class="table-responsive-sm">
            <table class="table b-table table-striped">
                <tbody class="">
<!--                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">등록일</label>
                    </td>
                      <td class="">
                        <span style="color:#ea0000; font-weight:bold; font-size:12px">* 등록일은 자동 등록됩니다.</span>
                        <b-row class="pt-sm-12">
                          <b-col sm="2"><b-form-input type="text" v-model="queryParams.reg_date" name="daterange" disabled /></b-col>
                        </b-row>
                      </td>
                  </tr>-->

                  <tr class="form_tr" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">노출여부</label>
                    </td>

                    <td class="" style="vertical-align:middle">
                      <c-switch type="text" variant="primary" v-model="queryParams.use_yn" on="On" off="Off" :pill="true" :checked="true" style="margin:0px"/>
                    </td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">제목</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="7">
                            <b-form-input id="basicText" name="nl_subject" type="text" v-model="queryParams.nl_subject" v-validate="'required'" :class="{'is-invalid': errors.has('nl_subject')}"></b-form-input>
                            <span v-show="errors.has('nl_subject')" :class="{error: errors.has('nl_subject')}">제목명은 필수 항목 입니다.</span>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">TAG</label>
                    </td>
                    <td class="tl" colspan="4">
                      <div style="float: left;">
                        <template v-if="!isCustomHashTag" v-for="tag in splitCustomHashTag">
                          <div class="badge badge-danger" style="font-size:14px; margin: 3px 3px 3px 3px; font-weight: 200;">{{ tag }}</div>
                        </template>
                      </div>

                      <div style="width: 12%; float: left;">
                        <button v-if="!isCustomHashTag" class="btn btn-outline-primary" style="margin-right: 5px;" @click="isCustomHashTag = !isCustomHashTag">수정</button>
                      </div>
                      <template v-if="isCustomHashTag">
                        <div style="width: 70%; float: left;">
                      <textarea style="width:100%;height:50px;"
                                v-model="queryParams.nl_tag"
                                placeholder="해시태그는 콤마(,) 으로 공백없이 작성해주세요."
                      ></textarea>
                        </div>
                        <div style="width: 30%; float: left; margin-top: 10px; padding-left: 20px;">
                          <button class="btn btn-outline-primary" @click="saveCustomHashTag">저장</button>
                          <!--                        <button class="btn btn-outline-danger" @click="isCustomHashTag = !isCustomHashTag">취소</button>-->
                        </div>
                      </template>
                    </td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">SUMMARY(개요)</label>
                    </td>
                    <td class="" colspan="4">
                      <vue-ckeditor v-model="queryParams.nl_summary" :config="config" />
                    </td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">내용</label>
                    </td>
                    <td class="" colspan="4">
                      <vue-ckeditor v-model="queryParams.nl_contents" :config="config" />
                    </td>
                  </tr>
                </tbody>
            </table>
          </div>
        </b-card>
      </b-col>
      <b-col md="12">
        <b-row style="margin-bottom:1.5em">
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            <div style="float:right; width:70%">
              <b-row>
                <b-col md="4">
                </b-col>
                <b-col md="4">
                  <b-button variant="success" v-on:click="saveDrNewsLetter()" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #248847; font-size:15px"><h5 style="margin-bottom:0px"><i class="fa fa-hand-o-up"></i> 등록</h5></b-button>
                </b-col>
                <b-col md="4">
                  <b-button variant="primary" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #187c9f; font-size:15px" v-bind:href="'#/letter/newsletter'"><i class="fa fa-list-ul"></i> 목록</h5></b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Vue from 'vue';
import datetimepicker from "daterangepicker/daterangepicker.js";
import ko from 'vee-validate/dist/locale/ko.js'
import swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'

const moment = require("moment");
import cSwitch from '../../components/Switch'
import VeeValidate from 'vee-validate';
import VueCkeditor from 'vue-ckeditor2';
Vue.use(VeeValidate, {
  locale: 'ko'
});

export default {
  components: {
    Multiselect,
    cSwitch,
    VueCkeditor
  },
  data() {
    return {
      newslettercode: '',
      newFlag:'new',
      pageOptions: [5, 10, 30, 50, 100],
      //ratingOptions: [], // 평가시 적립 포인트 코드 조회 => 평가시 적립 포인트 선택
      //ratingPointData: '',
      formtype: '',
      queryParams: {
        reg_date: moment().format('YYYY-MM-DD'),
      },
      calendarLocale: {
        "format": "YYYY-MM-DD",
        "separator": "~",
        "applyLabel": "적용",
        "cancelLabel": "취소",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "일", "월", "화", "수", "목", "금", "토"
        ],
        "monthNames": [
          "1월", "2월", "3월", "4월", "5월", "6월",
          "7월", "8월", "9월", "10월", "11월", "12월"
        ],
        "firstDay": 1
      },
      endDate: moment().format('YYYY-MM-DD'),
      startDate: moment().format('YYYY-MM-DD'),
      enabled: true,
      isCustomHashTag : false,

      config: {
        toolbar:[
          { name: 'document', items: [ 'Source', 'Preview'] },
          { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
          { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'PageBreak'] },
          '-',
          { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
          { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
          { name: 'links', items: ['Link', 'Unlink'] },
          '/',
          { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
          { name: 'colors', items: ['TextColor', 'BGColor'] },
          { name: 'tools', items: [ 'Maximize' ] },
          { name: 'about', items: [ 'About' ] }
        ],
        font_names: 'Noto Sans KR/Noto Sans KR,sans-serif;맑은 고딕/Malgun Gothic;굴림/Gulim;돋움/Dotum;바탕/Batang;궁서/Gungsuh;',
        filebrowserImageUploadUrl:'backend/ftpserver/ckeditImageUpload',
        uploadUrl: 'backend/ftpserver/ckeditImageUpload?command=QuickUpload&type=Files&responseType=json',
        height: 300,
        versionCheck: false,
        extraPlugins: 'tableresize'
      },
    }
  },
  watch: {
  },
  computed: {
    splitHashTag(){
      let datas = [];
      if(this.queryParams.nl_tag) datas = this.queryParams.nl_tag.split(/[,\s]+/);
      return datas;
    },
    splitCustomHashTag(){
      let datas = [];
      if(this.queryParams.nl_tag) datas = this.queryParams.nl_tag.split(/[,\s]+/);
      return datas;
    },
    sortedInterestList() {
      // 배열을 정렬하여 새로운 배열을 반환
      return this.interestList.sort((a, b) => a.item_seq < b.item_seq);
    }
  },
  mounted: function() {
    var token = sessionStorage.getItem("myToken");
    var self = this;
    self.formtype = self.$route.query.status;
    self.newslettercode = self.$session.get('newsLetterCode');

    if(self.formtype == 'update'){
      self.getDrNewsLetterData(self.newslettercode);
    }

    //self.getPointOptions();

    $(function() {
      $('input[name="daterange"]').daterangepicker({
        opens: 'left',
        singleDatePicker: true,
        "locale": self.calendarLocale,
        "endDate": moment().format('YYYY-MM-DD'),
        "startDate": moment().format('YYYY-MM-DD')
      }, function(start, end, label) {
        self.startDate = start.format('YYYY-MM-DD');
        self.queryParams.reg_date = self.startDate;
        self.endDate = end.format('YYYY-MM-DD');
      });
    });
  },
  methods: {



    saveCustomHashTag(){
      this.queryParams.nl_tag = this.queryParams.nl_tag.replace(/\s/g, '');

      let lastIndex = this.queryParams.nl_tag.lastIndexOf(',');
      let tagLenth = this.queryParams.nl_tag.length - 1;

      // 마지막 콤마 제거
      const lastCommaRegx = /,\s*$/;
      while(lastIndex === tagLenth){
        this.queryParams.nl_tag = this.queryParams.nl_tag.replace(lastCommaRegx, '');
        lastIndex = this.queryParams.nl_tag.lastIndexOf(',');
        console.log(lastIndex);
        tagLenth = this.queryParams.nl_tag.length - 1;
        if(this.queryParams.nl_tag === '') break;
      }
      this.isCustomHashTag = false;
    },

    /*
    ratingLabel ({ name, num }) {
      return `${name} - ${Number(num).toLocaleString()+'점'}`
    },
     */
    // 메소드명 : drFreeReportOption()
    // ### 무료 리포트 목록을 조회한다 ###
    // 무료 리포트 목록을 조회하여 해당 유료 컨텐츠의 요약본 다운로드에 필요한 링크 저장
    //
    // 최초작성 : 2016.07.21
    // 파라미터 :
    //  - dr_deth_code(그룹코드 값)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.07.21  황경현   최초작성
    // *************************
    /*
    getPointOptions() {
      var self = this;
      self.ratingOptions = [];
      var token = sessionStorage.getItem("myToken");
      self.$http.post('/api/select/drNewsLetterPointOptions?access_token=' + token, null)
        .then((result) => {
          var reportDatas = result.data;
          var pointROption = reportDatas.reportPointOptions;
          pointROption.forEach(function (el, idx, arr){
            var items = {
              name: el.point_name,
              code: el.point_code,
              num: el.point_num,
            };
            self.ratingOptions.push(items);
          });

          console.log(reportDatas);

          setTimeout(function(){
            if(self.formtype == 'update'){
              self.ratingOptions.forEach(function (el, idx, arr){
                if(el.code == self.queryParams.nl_rating_point_code){
                  self.ratingPointData = el;
                }
              });
            }else{
              self.ratingOptions.forEach(function (el, idx, arr){
                if(el.code == reportDatas.rating_point_code){
                  self.ratingPointData = el;
                  self.queryParams.nl_rating_point_code = el.code;
                }
              });
            }
          }, 100);

        })
    },
     */
    // 메소드명 : getDrNewsLetterData(val)
    // ### 리포트 데이터 갱신 ###
    // 메소드 저장후 데이터 갱신용으로 사용
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  - val(해당 필드의 value 값을 가져옴)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.06.10  황경현   최초작성
    // *************************
    getDrNewsLetterData(newslettercode) {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.$http.get('/api/select/drNewsLetterData?access_token=' + token + '&newslettercode=' + newslettercode)
      .then((result) => {
        self.queryParams = result.data;
      })
    },
    // 메소드명 : insertDrNewsLetter()
    // ### 뉴스레터 최초 저장 ###
    // 뉴스레터 최초 저장
    //
    // 최초작성 : 2019.10.30
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.10.30  황경현   최초작성
    // *************************
    saveDrNewsLetter() {
      var self = this;
      self.$validator.validateAll().then(success => {
        if (success) {
          var token = sessionStorage.getItem("myToken");
          self.queryParams.reg_id = self.$session.get('userId');

          if(!self.queryParams.nl_summary){
            swal.fire({
              type: 'warning',
              title: 'SUMMARY(개요) 부분은 필수로 작성해 주세요.',
              showConfirmButton: true,
            })
            return;
          }

          if(!self.queryParams.nl_contents){
            swal.fire({
              type: 'warning',
              title: '내용 부분은 필수로 작성해 주세요.',
              showConfirmButton: true,
            })
            return;
          }

          /*if(self.ratingPointData == null){
            swal.fire({
              type: 'error',
              title: '평가시 적립 R-POINT를</br> 설정해 주세요.',
              showConfirmButton: false,
              timer: 1500
            })
            return false;
          }*/

          //self.queryParams.nl_rating_point_code = self.ratingPointData.code;

          var param = encodeURI(JSON.stringify(self.queryParams));
          var data = new FormData();
          data.append('letterObj', param);

          console.log(self.queryParams);

          if(self.formtype == 'insert'){
            self.$http.post('/api/test/drNewsLetter?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '뉴스레터가 등록되었습니다.',
                  showConfirmButton: false,
                  timer: 2500
                }).then(function() {
                    window.location = "#/letter/newsletter";
                });
            })
          }else if(self.formtype == 'update'){
            self.$http.post('/api/update/drNewsLetter?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '뉴스레터를 수정하였습니다.',
                  showConfirmButton: false,
                  timer: 2500
                }).then(function() {
                    window.location = "#/letter/newsletter";
                });
            })
          }
        }
      })
    },
  }
}

</script>
<style lang="css" scoped>
.buttons {
  margin-top: 35px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.p20{
    padding:20px
}

.normal {
    background-color: grey;
}

.dragArea{
    min-height: 10px;
}

.sortable-chosen {
    opacity: 0.7;
    background-color:#dcdcdc;
}

.sortable-ghost {
    background-color:#dcdcdc;
}
.handle {
    padding: 5px;
    margin-right: 10px;
    border: solid #000 1px;
    cursor: move;
}

span.error {
  color: #9F3A38;
}


#VueTables__search_UBume {
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
<style src="daterangepicker/daterangepicker.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/letter/NewsLetterForm.vue